import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Drill = createSvgIcon(
  <path d="M14.25 0H3.284L0 3.284v7.204l2.828.008-.857 6.004H0V24h13.5v-4.688l-3.679-2.758.577-6.054h3.852V9h3.091L19.5 6.841V6.39l4.505-.02-.01-2.25-4.495.02v-.481L17.341 1.5H14.25V0ZM12 2.25v6H9.375c-.58 0-1.065.441-1.12 1.018L7.566 16.5H4.244l.995-6.966a1.125 1.125 0 0 0-1.11-1.284L2.25 8.245V4.216L4.216 2.25H12Zm4.409 4.5H14.25v-3h2.159l.841.841v1.318l-.841.841Zm-14.159 15v-3H9l2.25 1.688v1.312h-9Z" />,
  'Drill'
);

export { Drill };